<div class="modal-header">
  <h4 class="modal-title">Confirm Close</h4>
</div>
<div class="modal-body">
  Your Nailup timeout has expired. Please select one of the options below to
  continue.
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-secondary mx-1" (click)="break()">
    Break
  </button>
  <button type="button" class="btn btn-secondary mx-1" (click)="nailup()">
    Nailup Again
  </button>
</div>
